import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LayoutService } from './service/app.layout.service';
import { NavMenuService, NavRailSection, navColorFromBg } from './nav-menu.service';
import { NavigationHistoryService } from '../../core/services/navigation-history.service';

@Component({
  selector: 'app-nav-rail',
  templateUrl: './app.nav-rail.component.html',
  styleUrls: ['./app.nav-rail.component.scss'],
})
export class AppNavRailComponent implements OnInit, OnDestroy {
  sections: NavRailSection[] = [];
  activeId: string | null = null;
  previewId: string | null = null;
  readonly navColor = navColorFromBg;
  private subs: Subscription[] = [];

  constructor(
    public layoutService: LayoutService,
    private navMenu: NavMenuService,
    private router: Router,
    private navigationHistoryService: NavigationHistoryService
  ) {}

  ngOnInit(): void {
    this.subs.push(
      this.navMenu.sections$.subscribe(sections => {
        this.sections = sections;
      }),
      this.layoutService.activeRailId$.subscribe(id => {
        this.activeId = id;
      }),
      this.layoutService.previewRailId$.subscribe(id => {
        this.previewId = id;
      })
    );
  }

  onHover(section: NavRailSection): void {
    if (!this.layoutService.isDesktop()) return;
    this.layoutService.previewRail(section.id);
  }

  /**
   * Drop preview for this item when the pointer leaves it (unless moving to
   * another rail item or the detail panel). Prevents sticky --preview after select.
   */
  onItemLeave(section: NavRailSection, event: MouseEvent): void {
    const related = event.relatedTarget as HTMLElement | null;
    if (related?.closest?.('.nav-rail, .layout-nav__panel')) {
      return;
    }
    if (this.layoutService.getPreviewRailId() === section.id) {
      this.layoutService.clearPreview();
    }
  }

  onClick(section: NavRailSection, event?: Event): void {
    this.layoutService.clearPreview();
    this.layoutService.setActiveRailId(section.id, true);
    const target = event?.currentTarget as HTMLElement | undefined;
    // Drop sticky :hover/:focus styling after click (esp. touch / trackpad).
    target?.blur?.();
    const link =
      section.routerLink ||
      section.items?.find(i => !!i.routerLink)?.routerLink;
    if (link) {
      this.navigationHistoryService.removeAllValues();
      this.router.navigate(link);
    } else if (this.layoutService.detailPanelPinned) {
      // No primary route — keep panel on this section
      this.layoutService.setActiveRailId(section.id, true);
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}
